module.exports = __webpack_public_path__ + "static/img/xh3.a98d663.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xh3.png
// module id = gZIQ
// module chunks = 0